import { FiChevronsLeft, FiChevronsRight, FiLogOut } from "react-icons/fi";
import useLogout from "hooks/useLogout";
import useSidebar from "hooks/useSidebar";
import navItems from "components/sidebar/navItems";
import NavItem from "components/sidebar/NavItem";
import Logo from "components/common/Logo";

export default function Sidebar() {
  const { isCollapsed, isMobileOpen, closeMobile, toggleCollapse } = useSidebar();
  const { logout } = useLogout();

  const desktopWidth = isCollapsed ? "md:w-20" : "md:w-64";
  const mobileState = isMobileOpen ? "translate-x-0" : "-translate-x-full";

  return (
    <aside
      className={`fixed inset-y-0 left-0 z-40 flex w-64 flex-col overflow-x-hidden ${mobileState} ${desktopWidth} bg-brand-900 px-3 py-4 text-white transition-all duration-300 ease-out md:translate-x-0`}
    >
      <div className={`mb-6 flex items-center ${isCollapsed ? "justify-center" : "justify-between"}`}>
        <Logo
          showText={!isCollapsed}
          text="Fortify"
          logoClassName={isCollapsed ? "h-8 w-8" : "h-7 w-7"}
          textClassName="text-lg font-bold tracking-wide text-white"
        />
        <button
          type="button"
          onClick={toggleCollapse}
          className="hidden rounded-lg border border-white/20 p-2 text-white transition hover:bg-white/10 md:inline-flex"
          aria-label="Toggle sidebar"
        >
          {isCollapsed ? <FiChevronsRight /> : <FiChevronsLeft />}
        </button>
      </div>

      <nav className="flex-1 space-y-1 overflow-x-hidden overflow-y-auto pr-1">
        {navItems.map((item) => (
          <NavItem
            key={item.to}
            item={item}
            collapsed={isCollapsed}
            onNavigate={closeMobile}
          />
        ))}
      </nav>

      <button
        type="button"
        onClick={() => {
           logout().finally(() => closeMobile());
        }}
        className={`mt-3 flex items-center rounded-xl border-l-2 border-transparent px-3 py-2 text-sm font-medium text-slate-200 transition-all hover:bg-white/10 hover:text-white ${
          isCollapsed ? "justify-center" : "gap-3"
        }`}
        aria-label="Logout"
      >
        <FiLogOut className="text-lg" />
        {!isCollapsed && <span>Logout</span>}
      </button>
    </aside>
  );
}
